// src/app/layout/CoreHeader.tsx
import { Menu } from 'lucide-react';
import { CoreContextBadge } from './CoreContextBadge';
import { CoreThemeToggle } from './CoreThemeToggle';
import { NotificationArea } from './NotificationArea';
import { UserArea } from './UserArea';

interface CoreHeaderProps {
  onOpenNav: () => void;
}

/**
 * Top bar: mobile nav toggle + app title + context badge on the start
 * side, theme toggle + notifications + user area on the end side.
 * Each required region (context badge, notifications, theme toggle,
 * user area) is its own component — NotificationArea and UserArea are
 * reused unchanged from Step 1; CoreContextBadge and CoreThemeToggle
 * are new for this phase — so no region's markup is duplicated or
 * inlined here.
 */
export function CoreHeader({ onOpenNav }: CoreHeaderProps) {
  return (
    <header className="vania-command-header vania-shell-header">
      <div className="vania-shell-header-start">
        <button
          type="button"
          onClick={onOpenNav}
          aria-label="باز کردن منو"
          className="vania-shell-icon-button xl:hidden"
        >
          <Menu size={18} strokeWidth={2.2} />
        </button>
        <span className="vania-shell-header-copy">
          <span className="vania-shell-title">پنل مدیریت کل VaniaLabs</span>
        </span>
        <CoreContextBadge />
      </div>

      <div className="vania-shell-header-actions">
        <CoreThemeToggle />
        <NotificationArea />
        <UserArea />
      </div>
    </header>
  );
}
